import React from "react";

function Footer() {
  return (
    <div className="main-footer">
      <p style={{marginTop:'5px'}}>[ © 2025 Klingelnberg Work Holding ]&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[ v1.0 ]&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[ ® All rights reserved ]</p>
    </div>
  );
}

export default Footer;          